import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const PrivacyPolicy = () => {

  return (
    <Box sx={{ backgroundColor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 900,
            mb: 4,
            fontSize: { xs: '2rem', md: '2.8rem' },
            color: 'text.primary',
            textAlign: 'center',
          }}
        >
          Privacy Policy
        </Typography>

        <Typography sx={{ mb: 3, color: 'text.secondary', fontSize: '1.05rem' }}>
          <strong>Effective Date:</strong> August 27, 2025
        </Typography>

        <Section title="1. Information We Collect">
          When you submit our contact form, we collect the following:
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Message content</li>
          </ul>
          We do not collect cookies, IP addresses, or other personal information.
        </Section>

        <Section title="2. How We Use Your Information">
          Your information is used solely to respond to your inquiry. We do not use it for marketing or share it with third parties.
        </Section>

        <Section title="3. How We Protect Your Information">
          We take appropriate security measures to protect your information, including using HTTPS and secure handling of form submissions.
        </Section>

        <Section title="4. Data Retention">
          We retain contact form submissions only as long as needed to fulfill your request. Afterward, your data may be securely deleted.
        </Section>

        <Section title="5. Third-Party Services">
          This site does not use third-party tracking, analytics, or advertising services.
        </Section>

        <Section title="6. Your Rights">
          You may request access to, correction, or deletion of your data at any time. To do so, contact us using the contact form.
        </Section>

        <Section title="7. Contact Us">
          If you have any questions or concerns about this policy, please reach out through our contact form.
        </Section>

        <Section title="8. Changes to This Policy">
          We may update this Privacy Policy periodically. Any changes will be posted here with a revised effective date.
        </Section>
      </Container>
    </Box>
  );
};

// Helper subcomponent for each section
const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" sx={{ fontWeight: 700, color: 'text.primary', mb: 1 }}>
      {title}
    </Typography>
    <Typography sx={{ color: 'text.secondary', fontSize: '1rem', lineHeight: 1.7 }}>
      {children}
    </Typography>
  </Box>
);

export default PrivacyPolicy;